import { createContext, useContext } from "react";

import type { DividerSettings } from "../../../email-design/types/email-divider-settings";
import type { DeepPartial } from "react-hook-form";

/** The email design's divider styles, so a divider's style controls can start from them. */
export const DividerTemplateContext = createContext<DeepPartial<DividerSettings> | null>(null);

export function useDividerTemplate(): DeepPartial<DividerSettings> | null {
  return useContext(DividerTemplateContext);
}
